var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createDemoPeriodComparisonMatcher } from '@web/lib/demo/utils';
import { calculateAverage, formatReplyRateDisplay, getInterval, getPercentageDiff, getPreviousPeriod, groupByPeriod, randomInt, toReplyRatePercent } from '@workalizer/shared/utils';
import { endOfDay, startOfDay } from 'date-fns';
var TEAM_USER_COUNT = 8;
export var emailSummaryReplyRate = function (input) {
    var interval = getInterval(input.dateFrom, input.dateTo);
    var dateFrom = startOfDay(input.dateFrom);
    var dateTo = endOfDay(input.dateTo);
    var _a = getPreviousPeriod(input.dateFrom, input.dateTo), prevPeriodDateFrom = _a.prevPeriodDateFrom, prevPeriodDateTo = _a.prevPeriodDateTo;
    var periods = groupByPeriod([], dateFrom, dateTo, interval);
    var previousPeriods = groupByPeriod([], startOfDay(prevPeriodDateFrom), endOfDay(prevPeriodDateTo), interval);
    var periodMatcher = createDemoPeriodComparisonMatcher(input, interval, periods, previousPeriods);
    var totalReceived = 0;
    var totalOpened = 0;
    var totalReplied = 0;
    var prevTotalReceived = 0;
    var prevTotalOpened = 0;
    var prevTotalReplied = 0;
    var chartPeriods = periods.map(function (period, index) {
        var _a;
        var received = randomInt(40, 120);
        var opened = randomInt(20, Math.max(20, received - 5));
        var replied = randomInt(10, Math.max(10, opened - 5));
        var prevPeriod = periodMatcher.getItem(index, previousPeriods);
        var prevReceived = randomInt(40, 120);
        var prevOpened = randomInt(20, Math.max(20, prevReceived - 5));
        var prevReplied = randomInt(10, Math.max(10, prevOpened - 5));
        totalReceived += received;
        totalOpened += opened;
        totalReplied += replied;
        prevTotalReceived += prevReceived;
        prevTotalOpened += prevOpened;
        prevTotalReplied += prevReplied;
        return {
            period: period.date,
            previousPeriodLabel: (_a = prevPeriod === null || prevPeriod === void 0 ? void 0 : prevPeriod.date) !== null && _a !== void 0 ? _a : '',
            received: received,
            opened: opened,
            replied: replied,
            prevReceived: prevReceived,
            prevOpened: prevOpened,
            prevReplied: prevReplied
        };
    });
    var currentOpenedRate = toReplyRatePercent(totalOpened, totalReceived);
    var previousOpenedRate = toReplyRatePercent(prevTotalOpened, prevTotalReceived);
    var currentRepliedRate = toReplyRatePercent(totalReplied, totalReceived);
    var previousRepliedRate = toReplyRatePercent(prevTotalReplied, prevTotalReceived);
    var teamReceived = input.userId
        ? Math.round(totalReceived * TEAM_USER_COUNT * 0.9)
        : 0;
    var teamOpened = input.userId
        ? Math.round(totalOpened * TEAM_USER_COUNT * 0.88)
        : 0;
    var teamReplied = input.userId
        ? Math.round(totalReplied * TEAM_USER_COUNT * 0.85)
        : 0;
    var teamOpenedRate = toReplyRatePercent(teamOpened, teamReceived);
    var teamRepliedRate = toReplyRatePercent(teamReplied, teamReceived);
    return {
        periods: chartPeriods,
        totals: {
            received: __assign({ count: totalReceived, previous: getPercentageDiff(prevTotalReceived, totalReceived) }, (input.userId && {
                teamAverage: getPercentageDiff(calculateAverage(teamReceived, TEAM_USER_COUNT), totalReceived)
            })),
            opened: __assign({ count: totalOpened, rate: currentOpenedRate, previous: __assign(__assign({}, getPercentageDiff(previousOpenedRate, currentOpenedRate)), { comparisonValueDisplay: formatReplyRateDisplay(prevTotalOpened, previousOpenedRate) }) }, (input.userId && {
                teamAverage: __assign(__assign({}, getPercentageDiff(teamOpenedRate, currentOpenedRate)), { comparisonValueDisplay: formatReplyRateDisplay(calculateAverage(teamOpened, TEAM_USER_COUNT), teamOpenedRate) })
            })),
            replied: __assign({ count: totalReplied, rate: currentRepliedRate, previous: __assign(__assign({}, getPercentageDiff(previousRepliedRate, currentRepliedRate)), { comparisonValueDisplay: formatReplyRateDisplay(prevTotalReplied, previousRepliedRate) }) }, (input.userId && {
                teamAverage: __assign(__assign({}, getPercentageDiff(teamRepliedRate, currentRepliedRate)), { comparisonValueDisplay: formatReplyRateDisplay(calculateAverage(teamReplied, TEAM_USER_COUNT), teamRepliedRate) })
            }))
        }
    };
};
